import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
// import '../assets/css/icons.css';
import "../../assets/css/style.css";
import { SERVER_IP, PORT, ud, auth_response_flow, jwt, LICENSE } from "../../Server";
import axios from "axios";
import DashboardChart from "./userChart";
import swal from "sweetalert";
// import history from '../../history';
import upcoming from "../../assets/images/upcoming.png";
import pending from "../../assets/images/pending.png";
import ongoing from "../../assets/images/ongoing.png";
import { HomeIcon, OnGoingIcon, PendingIcon, UpcomingIcon } from "../../assets/Icons";
import HeaderMobileSearch from "../../common/HeaderMobileSearch";
import { connect } from "react-redux";
import HeaderMobile from "../../common/HeaderMobile";

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alignedWorkflowLength: 0,
      alignedWorkflows: [],
      user_info: {},
      imgPrefix: SERVER_IP + ":" + PORT + "/icons",
      totalExecutedworkflow: 0,
      _Completed: 0,
      _OnProgress: 0,
      call_logs: [],
      call_info: {},
      call_barChartData: [],
      loading: true,
      min_range: 0,
      max_range: 150000,
      total_callLogs: 0
    };
  }

  componentDidMount() {
    // const location = {
    //     pathname: '/create/contectlist',
    //     state: { fromDashboard: true }
    // }
    // history.push(location)

    this.UserData();
    this.SiteDashInfo();
    this.dataByLicense();
  }

  dataByLicense = () => {
    // if (LICENSE.application_Dashboard) {
    //     if (LICENSE.application_Dashboard.enable_analytics == 1) {
    this.CallLogsInfo();
    this.CallLogsData();
    this.CallLogsList(0, 150000);
    this.setState(this.state);
    //     }
    // } else {
    //     setTimeout(() => {
    //         this.dataByLicense()
    //     }, 1000)
    // }
  };

  SiteDashInfo = () => {
    var data = {
      user_id: ud.id,
    };
    var _this = this;
    var _OnProgress = 0;
    var _Completed = 0;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/workflowList`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.data.error === false) {
          response.data.workflowList.map((list, index) => {
            _OnProgress = _OnProgress + list.workflow_total_ongoing;
            _Completed = _Completed + (list.workflow_total_completed === 0 ? 1: 0);
          });
          _this.setState({
            alignedWorkflowLength: response.data.workflowList.length,
            alignedWorkflows: response.data.workflowList,
            _Completed: _Completed,
            _OnProgress: _OnProgress,
          });
        } else {
          auth_response_flow(response.data, (return_response) => {
            if (return_response.error === false && return_response.retry === true) {
              _this.SiteDashInfo();
            }
          });
        }
      })
      .catch(function (error) {
        console.log(error);
        swal("Something Went Wrong,Please Retry");
      });
  };

  CallLogsInfo = () => {
    var data = {
      user_id: ud.id,
    };
    var _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/callstatistics`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.data.error === false) {
          _this.setState({ call_logs: response.data.Data });
        } else {
          auth_response_flow(response.data, (return_response) => {
            if (return_response.error === false && return_response.retry === true) {
              _this.CallLogsInfo();
            }
          });
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong,Please Retry");
      });
  };

  UserData = () => {
    var data = {
      s_id: "",
      user_id: ud.id,
      user_type: 3,
    };
    var _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/usersList`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.data.error === false) {
          if (response.data.usersList.length == 1) {
            _this.setState({ user_info: response.data.usersList[0] });
          }
        } else {
          auth_response_flow(response.data, (return_response) => {
            if (return_response.error === false && return_response.retry === true) {
              _this.UserData();
            }
          });
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong,Please Retry");
      });
  };

  CallLogsData = () => {
    var data = {
      user_id: ud.id,
      year: new Date().getFullYear(),
    };
    var _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/dashboardUser`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.data.error === false) {
          let mon = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
          let BarData = [];
          mon.map((list, index) => {
            let findobj = response.data.barChartData.find((raw) => raw.month == list);
            if (findobj) {
              BarData.push(findobj.totalCalls);
            } else {
              BarData.push(0);
            }
          });
          _this.setState({
            call_info: response.data.totalCallDetails[0],
            call_barChartData: BarData,
            loading: false,
          });
        } else {
          auth_response_flow(response.data, (return_response) => {
            if (return_response.error === false && return_response.retry === true) {
              _this.CallLogsData();
            }
          });
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong,Please Retry");
      });
  };

  CallLogsList = async (min_range, max_range) => {
    this.setState({ loading: true });

    const stored = sessionStorage.getItem("call_staistics");
    const other_id = stored ? JSON.parse(stored).to_user : 0;

    const headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };

    const payload = {
      user_id: ud.id,
      min_limit: min_range,
      max_limit: max_range,
      other_id,
    };

    try {
      const { data } = await axios.post(`${SERVER_IP}/calllogs`, payload, {
        withCredentials: true,
        headers,
      });

      if (!data.error) {
         this.setState({
          total_callLogs: data.call_logs.length
         })
      } else {
        auth_response_flow(data, (res) => {
          if (res.error === false && res.retry) {
            this.CallLogsList(min_range, max_range);
          } else {
            this.setState({ loading: false, message: "No Record Found" });
          }
        });
      }
    } catch (err) {
      swal("Something Went Wrong, Please Retry");
      this.setState({ loading: false, message: "No Record Found" });
    }
  };

  changeYear = (year) => {
    var data = {
      user_id: ud.id,
      year: year,
    };
    var _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/dashboardUser`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.data.error === false) {
          let mon = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
          let BarData = [];
          mon.map((list, index) => {
            let findobj = response.data.barChartData.find((raw) => raw.month == list);
            if (findobj) {
              BarData.push(findobj.totalCalls);
            } else {
              BarData.push(0);
            }
          });
          _this.setState({
            call_info: response.data.totalCallDetails.length > 0 ? response.data.totalCallDetails[0] : {},
            call_barChartData: BarData,
          });
        } else {
          auth_response_flow(response.data, (return_response) => {
            if (return_response.error === false && return_response.retry === true) {
              _this.changeYear(year);
            }
          });
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong,Please Retry");
      });
  };

  render() {
    const errors = this.state.errors;
    const { user } = this.props;
    const { isMobile } = user;
    let Years = [];
    const userDetails = user.userDetails;

    for (let i = 2020; i <= new Date().getFullYear(); i++) {
      Years.push(i);
    }
    const { loading } = this.state;
    return (
      <>
        {isMobile && <HeaderMobile />}
        <div className="xp-breadcrumbbar xp-heading">
          <div className="row ">
            <div className="col-md-6 col-lg-6">
              <h4 className="xp-page-title">
                Welcome, {ud.username}{" "}
                <span className="starrating">
                  <strong>
                    ({(this.state.user_info.final_rating ? this.state.user_info.final_rating : 0).toFixed(1)}{" "}
                    <i className="fa fa-star text-dark"></i>)
                  </strong>
                </span>
              </h4>
            </div>
            <div className="col-md-12 col-lg-12">
              <div className="xp-breadcrumb gradient-border">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a onClick={() => (window.location.href = "/dashboard")}>
                      <HomeIcon />{" "}
                    </a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    {userDetails?.user?.group?.name}
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <div className="xp-contentbar p-30">
          <div className="row home-element">
            {/* <div className="col-sm-6 col-12 col-md-6 col-lg-6 col-xl-6">
                            <div className="card bg-white m-b-30">
                                <div className="card-body">
                                    <div className="xp-widget-box">
                                        <div className="float-left"> */}
            {/* <h4 className="xp-counter text-dark">{this.state.alignedWorkflowLength}</h4> */}
            {/* <h4 className="xp-counter text-dark">
                                                {(this.state.user_info.final_rating ? this.state.user_info.final_rating : 0).toFixed(1)} <i className="fa fa-star text-dark"></i>
                                                </h4>

                                            <p className="mb-0 font-17 text-dark">  User Rating</p>
                                        </div>
                                        <div className="float-right">
                                            <div className="xp-widget-icon xp-widget-icon-bg bg-primary">
                                                <img src={`${this.state.imgPrefix}/${this.state.user_info.profile}`} alt="Rounded Image" className="rounded-circle" />
                                            </div>
                                        </div>
                                        <div className="clearfix"></div>
                                    </div>
                                </div>
                            </div>
                        </div> */}

            <div className="col-sm-6 col-12 col-md-4 col-lg-4 col-xl-4">
              <div className="card bg-white">
                <div className="card-body">
                  <div className="xp-widget-box">
                    <div>
                      {loading ? (
                        <div className="skeleton" style={{ height: "1.5rem", width: "3rem" }} />
                      ) : (
                        <h4 className="xp-counter">{this.state.alignedWorkflowLength}</h4>
                      )}
                      <p className="mb-0 font-12 text-dark text-center"> Upcoming Workflow</p>
                    </div>
                    <div className="xp-widget-icon xp-widget-icon-bg">
                      <i className="">
                        {" "}
                        <UpcomingIcon />{" "}
                      </i>
                      {/* <img src={upcoming} alt="" /> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-sm-6 col-12 col-md-4 col-lg-4 col-xl-4">
              <div className="card bg-white">
                <div className="card-body">
                  <div className="xp-widget-box">
                    <div>
                      {loading ? (
                        <div className="skeleton" style={{ height: "1.5rem", width: "3rem" }} />
                      ) : (
                        <h4 className="xp-counter">{this.state._Completed}</h4>
                      )}
                      <p className="mb-0 font-12 text-dark">Pending Workflow</p>
                    </div>
                    <div className="xp-widget-icon xp-widget-icon-bg">
                      <i className="">
                        <PendingIcon />{" "}
                      </i>
                      {/* <img src={pending} alt="" /> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-12 col-md-4 col-lg-4 col-xl-4">
              <div className="card bg-white">
                <div className="card-body">
                  <div className="xp-widget-box">
                    <div>
                      {loading ? (
                        <div className="skeleton" style={{ height: "1.5rem", width: "3rem" }} />
                      ) : (
                        <h4 className="xp-counter">{this.state._OnProgress}</h4>
                      )}
                      <p className="mb-0 font-12 text-dark text-center">Number of ongoing Workflow</p>
                    </div>
                    <div className="xp-widget-icon xp-widget-icon-bg">
                      <i className="">
                        <OnGoingIcon />{" "}
                      </i>
                      {/* <img src={ongoing} alt="" /> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* {LICENSE.application_Dashboard ? (
                LICENSE.application_Dashboard.enable_analytics == 1 ? ( */}

          <DashboardChart
            WorkflowList={this.state.alignedWorkflows}
            call_logs={this.state.call_logs}
            call_info={this.state.call_info}
            total_callLogs={this.state.total_callLogs}
            call_barChartData={this.state.call_barChartData}
            changeYear={this.changeYear}
            Years={Years}
            loading={this.state.loading}
          />

          {/* ) : null
              ) : null} */}
        </div>
      </>
    );
  }
}
// export default

const mapStateToProps = (state) => ({
  user: state.userData,
});

export default connect(mapStateToProps)(Dashboard);
